import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { 
    GetInspectionInvoiceSubmissionInfoResponse, GetInspectionProposalInspectionInfoResponse, 
    InspectionProposalDetailsModel, RequestedInspectorCountryResponse, RequestedInspectorResponse, 
    RightShipInspectionDetailsModel, SaveInspectionProposalRequest, SaveInspectionProposalResponse, 
    SubmitRightShipInspectionInvoiceRequest, SubmitRightShipInspectionInvoiceResponse, CancelInspectionRequest,
    GetReviseProposalInspectionResponse,
    WithdrawInspectionRequest,
    RescheduleInspectionRequest,
    GetCurrentUserInfoResponse,
    RescheduleInspectionResponse,
    InspectionOutcomeReportModel
} from "../models/rightship-inspections.models";
import { RSInspectionApiEndpointConstants } from "../constants/api-endpoint.constants";

@autoinject()
export class RightshipInspectionService {

    public baseUrl: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/RightShipInspection`;
    
    constructor(private requestClient: RequestClientService, private configService: ConfigService) { }

    public getRequestedInspectorCountries(inspectionCompanyId: number): Promise<RequestedInspectorCountryResponse> {
        return this.requestClient.get<RequestedInspectorCountryResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetRequestedInspectorCountries}`, {
            inspectionCompanyId: inspectionCompanyId
        });
    }

    public getRequestedInspectors(countryId: number, inspectionId: number) : Promise<RequestedInspectorResponse> {
        return this.requestClient.get<RequestedInspectorResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetRequestedInspectors}`, {
            countryId: countryId,
            inspectionId: inspectionId
        });
    }

    public getInspectionProposalDetails(encryptedData: string): Promise<InspectionProposalDetailsModel> {
        return this.requestClient.get<InspectionProposalDetailsModel>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetInspectionProposalDetails}`, {
            encryptedInspectionData: encryptedData
        });
    }

    public saveInspectionProposal(request: SaveInspectionProposalRequest, encryptedData: string): Promise<SaveInspectionProposalResponse> {
        return this.requestClient.post<SaveInspectionProposalResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.SaveInspectionProposal}`, { encryptedInspectionData: encryptedData }, request);
    }

    public getInspectionProposalInspectionInfo(encryptedData: string): Promise<GetInspectionProposalInspectionInfoResponse> {
        return this.requestClient.get<GetInspectionProposalInspectionInfoResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetInspectionProposalInspectionInfo}`, {
            encryptedInspectionData: encryptedData
        });
    }

    public getInspectionInvoiceSubmissionInfo(encryptedData: string): Promise<GetInspectionInvoiceSubmissionInfoResponse> {
        return this.requestClient.get<GetInspectionInvoiceSubmissionInfoResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetInspectionInvoiceSubmissionInfo}`, {
            encryptedInspectionData: encryptedData
        });
    }

    public submitRightShipInspectionInvoice(request: SubmitRightShipInspectionInvoiceRequest, encryptedData: string): Promise<SubmitRightShipInspectionInvoiceResponse> {
        return this.requestClient.postFormData(`${this.baseUrl}/${RSInspectionApiEndpointConstants.SubmitRightShipInspectionInvoice}?encryptedInspectionData=${encryptedData}`, request);
    }

    public getRightShipInspectionDetails(encryptedData: string): Promise<RightShipInspectionDetailsModel> {
        return this.requestClient.get<RightShipInspectionDetailsModel>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetRightShipInspectionDetails}`, {
            encryptedInspectionData: encryptedData
        });
    }
    
    public cancelInspection(request: CancelInspectionRequest): Promise<any> {
        return this.requestClient.post<any>(`${this.baseUrl}/cancelinspection`, {}, request);
    }

    public getReviseProposalInspection(encryptedData: string): Promise<GetReviseProposalInspectionResponse> {
        return this.requestClient.get<GetReviseProposalInspectionResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetReviseProposalInspection}`, {
            encryptedInspectionData: encryptedData
        });
    }

    public getGetCurrentUserInfo(encryptedData: string): Promise<GetCurrentUserInfoResponse> {
        return this.requestClient.get<GetCurrentUserInfoResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetCurrentUserInfo}?encryptedInspectionData=${encryptedData}`);
    }

    public submitReviseOfferProposalInspection(encryptedData: string, request: SaveInspectionProposalRequest): Promise<SaveInspectionProposalResponse> {
        return this.requestClient.post<SaveInspectionProposalResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.SubmitReviseOfferProposalInspection}`, { 
            encryptedInspectionData: encryptedData 
        }, request);
    }

    public withdrawInspection(encryptedData: string, request: WithdrawInspectionRequest): Promise<SaveInspectionProposalResponse> {
        return this.requestClient.post<SaveInspectionProposalResponse>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.SubmitWithdrawalProposalInspection}`, { 
            encryptedInspectionData: encryptedData 
        }, request);
    }

    public rescheduleInspection(encryptedData: string, request: RescheduleInspectionRequest): Promise<RescheduleInspectionResponse> {
        return this.requestClient.post<any>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.RescheduleInspection}`, { 
            encryptedInspectionData: encryptedData 
        }, request);
    }

    public getInspectionOutcomeReportModel(encryptedData: string): Promise<InspectionOutcomeReportModel> {
        return this.requestClient.get<InspectionOutcomeReportModel>(`${this.baseUrl}/${RSInspectionApiEndpointConstants.GetInspectionOutcomeReportModel}`, {encryptedData: encryptedData});
    }
}